import { WSPage } from "@wingspanhq/fe-component-library";
import { RouteComponentProps } from "react-router-dom";
import { WSQueries } from "../../../../../query/WSQuery";
import { useQueryPayee } from "../../../../../query/payee/queries/useQueryPayee";
import { useQueryRequirement } from "../../../../../query/requirements/queries/useQueryRequirement";
import { RequirementsDetailsRoute } from "./RequirementsDetailsRoute";
import { useBulkReviewRequirements } from "../../../../BulkReview/hooks/useBulkReviewRequirements";

export const RouteRequirementDetails: React.FC<
  RouteComponentProps<{
    payeeId: string;
    requirementId: string;
  }>
> = ({
  match: {
    params: { requirementId, payeeId }
  }
}) => {
  const queryPayee = useQueryPayee(payeeId, {
    staleTime: Infinity
  });
  const queryRequirement = useQueryRequirement(requirementId, {
    staleTime: Infinity
  });

  useBulkReviewRequirements(requirementId);

  return (
    <WSPage>
      <WSQueries
        queries={{
          queryPayee,
          queryRequirement
        }}
      >
        {({ queryPayeeData, queryRequirementData }) => {
          return (
            <RequirementsDetailsRoute
              payee={queryPayeeData}
              requirement={queryRequirementData}
            />
          );
        }}
      </WSQueries>
    </WSPage>
  );
};
